import React from "react";
import styled from "styled-components";
import { tokens } from "../../theme/tokens";

// PageHeader — title + subtitle + right-aligned actions slot. Used by PageLayout
// and standalone at the top of page content. Optional eyebrow + breadcrumb slot.
//
//   <PageHeader title="Riders" subtitle="Manage rider accounts"
//               eyebrow="Fleet" actions={<Button>Add rider</Button>} />

const { colors, spacing, typography } = tokens;

const Root = styled.header`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: ${spacing[4]};
    flex-wrap: wrap;
    padding-bottom: ${spacing[4]};
    margin-bottom: ${spacing[5]};
    border-bottom: 1px solid ${colors.divider};
`;

const Titles = styled.div`
    min-width: 0;
`;

export const Eyebrow = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: ${typography.size.xs};
    font-weight: ${typography.weight.bold};
    letter-spacing: ${typography.tracking.wider};
    text-transform: uppercase;
    color: ${colors.primary};
    margin-bottom: 8px;
    &::before {
        content: "";
        width: 18px;
        height: 2px;
        border-radius: 2px;
        background: ${colors.primary};
    }
`;

const Title = styled.h1`
    margin: 0;
    font-family: ${typography.fonts.body};
    font-size: ${typography.size["2xl"]};
    font-weight: ${typography.weight.extrabold};
    letter-spacing: ${typography.tracking.tight};
    color: ${colors.heading};
    line-height: ${typography.leading.tight};
`;

const Subtitle = styled.p`
    margin: 6px 0 0;
    font-size: ${typography.size.md};
    color: ${colors.muted};
    line-height: ${typography.leading.snug};
`;

const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing[2]};
    flex-shrink: 0;
`;

export default function PageHeader({ eyebrow, title, subtitle, actions, ...rest }) {
    return (
        <Root {...rest}>
            <Titles>
                {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                <Title>{title}</Title>
                {subtitle && <Subtitle>{subtitle}</Subtitle>}
            </Titles>
            {actions && <Actions>{actions}</Actions>}
        </Root>
    );
}
